/**
 * 百音技能商店 — 品牌文案单一来源 (Single Source of Truth)
 *
 * 所有页面/组件的产品名、Slogan、SEO 文案均从此处引用。
 * 修改品牌文案 = 只改这一个文件。
 */

const BRAND = {
  // 产品名（短名 / 长名）
  name: '百音技能商店',
  nameEn: 'Baiyin Skills',
  fullName: '百音技能商店 — 音乐行业 AI 技能与专家市场',

  // Slogan
  slogan: '专注音乐行业的 AI 技能商店',
  sloganShort: '专注音乐行业的 AI 技能商店',

  // 首页 Hero 区
  heroHeadline: '百音技能商店',
  heroSubheadline: '专注音乐行业的 AI 技能商店，5 秒接入你的智能体（Openclaw / Hermes / Claude / Codex 等）',

  // 标语 / 描述
  tagline: '为音乐人、版权方、品牌方打造的 AI 技能商店与专家网络',
  description:
    '百音技能商店为音乐人、版权方、品牌方提供垂直 AI 技能与专家服务。对话即安装，5 秒接入 Openclaw / Hermes / Claude / Codex 等各类智能体。',

  // 三大核心卖点（首页 / 落地页）
  pillars: [
    {
      icon: '🎯',
      title: '音乐行业垂直',
      desc: '不是通用 AI 商店，每个技能都为音乐人、版权方、品牌方而生',
    },
    {
      icon: '💬',
      title: '对话即安装',
      desc: '不写代码、不装 CLI——一句话喂给 Openclaw / Hermes / Claude / Codex 就能用',
    },
    {
      icon: '🧑‍🎤',
      title: '专家随时在线',
      desc: '80% 撮合达成率，1.5 万达人直触，海葵集团版权资源背书',
    },
  ],

  // 导航 / 页面标题
  nav: {
    home: '首页',
    skills: '技能商店',
    experts: '音乐行业专家',
    publish: '上架技能',
    login: '登录',
    register: '注册',
    dashboard: '我的',
  },

  // 详情页 tab
  tabs: {
    overview: '能做什么',
    install: '怎么用',
    versions: '版本历史',
    reviews: '评测报告',
  },

  // 按钮 / 动作
  actions: {
    install: '领取技能',
    publish: '上架技能',
    favorite: '收藏',
    share: '分享',
  },

  // 域名 / URL
  domain: 'skillshub.hikoon.com',
  url: 'https://skillshub.hikoon.com',
  installManifestUrl: 'https://skillshub.hikoon.com/install/baiyin.md',

  // 公司 / 法务
  company: '海葵网海科技',
  copyright: `© ${new Date().getFullYear()} 海葵网海科技 · 百音技能商店`,

  // HTML head
  htmlTitle: '百音技能商店 — 音乐行业 AI 技能与专家市场',
  metaDescription:
    '百音技能商店为音乐人、版权方、品牌方提供垂直 AI 技能与专家服务。对话即安装，5 秒接入 Openclaw / Hermes / Claude / Codex 等各类智能体。',
  metaKeywords: '百音技能商店,音乐 AI,音乐行业 AI,AI 技能商店,音乐推广,版权运营,品牌音乐营销,Skills',
};

export default BRAND;
